import Typography from 'components/Atoms/Typography';
import { Icon } from 'components/Icons';
import { useSelector } from 'react-redux';
import { sendAmplitudeEvents } from 'utils/common';
import { EventNames } from 'utils/events';

import './index.css';

const YamlActionsContainer = ({
  changeConcurrencyValue,
  changeRetryValue,
  changeTimeoutValue,
  concurrencyValue,
  currentOsSelection,
  handleOsChange,
  retryValue,
  setToggleActive,
  timeoutValue,
  toggleActive,
}) => {
  const currentConfiguration = useSelector(
    (state) => state.onboarding?.currentConfigurationQuickRun
  );
  const handleSkipAmplitudeEvents = function () {
    sendAmplitudeEvents(EventNames.HYP_ONBOARDING_SKIP_LINK_QUICK_RUN, {
      'testing framework': currentConfiguration?.frameworkType,
      language: currentConfiguration?.framework?.language,
      framework: currentConfiguration?.framework?.name,
    });
  };
  const ActionsData = [
    {
      name: 'Concurrency',
      description:
        'The number of concurrent sessions allowed to run on HyperExecute',
      value: concurrencyValue,
      handler: changeConcurrencyValue,
    },
    {
      name: 'Retry',
      description:
        'No. of retry attempts to be done for a failed test (*max 10)',
      value: retryValue,
      handler: changeRetryValue,
    },
    {
      name: 'Timeout',
      description:
        'Total time in mins after which test execution should end (*max 120)',
      value: timeoutValue,
      handler: changeTimeoutValue,
    },
  ];
  return (
    <div className="yaml-actions-container">
      <div className="quick-run-content-heading">
        {' '}
        Configure HyperExecute Yaml
      </div>

      <Typography
        variant="subtext-1"
        className="yaml-actions-container-sub-heading gray-666"
      >
        Hyperexecute runs based on your inputs in a simple YAML configuration
        file.
      </Typography>
      {!!toggleActive && (
        <div className="yaml-actions-container-inner">
          <div className="os-container-section">
            <Typography variant="subtext-1" className="os-selection-text">
              Choose your preferred OS:
            </Typography>
            <div className="os-button-container">
              <button
                onClick={() => handleOsChange(0)}
                className={`os-control-button ${
                  currentOsSelection === 0 ? 'os-control-button-active' : ''
                }`}
              >
                <Icon
                  name="onboard/windows-dark"
                  color={currentOsSelection === 0 ? '#101010' : '#333333'}
                />
                <span className="os-name"> Windows</span>
              </button>
              <button
                onClick={() => handleOsChange(1)}
                className={`os-control-button ${
                  currentOsSelection === 1 ? 'os-control-button-active' : ''
                }`}
              >
                <Icon
                  name="onboard/linux-dark"
                  color={currentOsSelection === 1 ? '#101010' : '#333333'}
                />
                <span className="os-name"> Linux</span>
              </button>
            </div>
          </div>
          {ActionsData.map((action, index) => {
            return (
              <div className="action-field-container" key={index}>
                <div className="action-field-text-content">
                  <div className="action-field-text-heading">{action.name}</div>
                  <Typography
                    variant="subtext-1"
                    className="action-field-text-description"
                  >
                    {action.description}
                  </Typography>
                </div>
                <div className="concurrency-input-container action-field-input-container">
                  <input
                    className="concurrency-input-field action-field-input-field"
                    value={action.value}
                    onChange={(e) => action.handler(e?.target?.value)}
                    aria-label="action-field-input-field"
                  ></input>
                </div>
              </div>
            );
          })}
          <div
            className="skip-button-container"
            as="button"
            role="button"
            onKeyDown={() => {}}
            tabIndex={0}
            onClick={() => {
              handleSkipAmplitudeEvents();
              setToggleActive((currentState) => !currentState);
            }}
          >
            Skip
          </div>
        </div>
      )}
    </div>
  );
};

export default YamlActionsContainer;
